const $dskNavBtn = $(".main-nav div:not(:last-child) a");
const $loginBtn = $('#dsk-menu-app');
const $body = document.querySelector('body');
const $html = document.querySelector('html');
const $heroOwnerBtn = document.querySelector('.hero-cta .btn');

$dskNavBtn.click(function () {
    console.log('click on locum link');
    //  $body.classList.add('moveBody');
    $loginBtn.click(function () {
        console.log('btn login');
        return;
    });
    $html.style.backgroundColor = 'rgba(135, 206, 235, 0.45)';
    // $html.style.backgroundColor = '#fff';
    // $body.style.opacity = "0";
});


$(document).ready(function(){

    /*! Fades in page on load */
    // $body.style.opacity = "1";
    // $heroOwnerBtn.style.transform = "rotate(4deg)";
    // $heroOwnerBtn.classList.add('wiggle');

});